import { render, staticRenderFns } from "./KdsAdminDashboard.vue?vue&type=template&id=b7a46e08&scoped=true"
import script from "./KdsAdminDashboard.vue?vue&type=script&lang=js"
export * from "./KdsAdminDashboard.vue?vue&type=script&lang=js"
import style0 from "./KdsAdminDashboard.vue?vue&type=style&index=0&id=b7a46e08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a46e08",
  null
  
)

export default component.exports